import { apiSlice } from './apiSlice';

export const orgApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOrgMe: builder.query({
      query: () => '/org/me',
      providesTags: ['OrgMe'],
    }),
    patchOrganizationName: builder.mutation({
      query: ({ accountId, name }) => ({
        url: `/org/${accountId}`,
        method: 'PATCH',
        body: { name },
      }),
      invalidatesTags: ['OrgMe'],
    }),
    getOrgMembers: builder.query({
      query: ({ accountId }) => `/org/${accountId}/members`,
      providesTags: (result, error, arg) => [{ type: 'OrgMembers', id: arg.accountId }],
    }),
    getOrgInvites: builder.query({
      query: ({ accountId }) => `/org/${accountId}/invites`,
      providesTags: (result, error, arg) => [{ type: 'OrgMembers', id: `${arg.accountId}-invites` }],
    }),
    inviteOrgMember: builder.mutation({
      query: ({ accountId, email, role }) => ({
        url: `/org/${accountId}/invite`,
        method: 'POST',
        body: { email, role },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'OrgMembers', id: `${arg.accountId}-invites` }],
    }),
    resendOrgInvite: builder.mutation({
      query: ({ accountId, token }) => ({
        url: `/org/${accountId}/invites/${token}/resend`,
        method: 'POST',
      }),
    }),
    deleteOrgInvite: builder.mutation({
      query: ({ accountId, token }) => ({
        url: `/org/${accountId}/invites/${token}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'OrgMembers', id: `${arg.accountId}-invites` }],
    }),
    acceptOrgInvite: builder.mutation({
      query: ({ accountId, token }) => ({
        url: `/org/${accountId}/invite/accept`,
        method: 'POST',
        body: { token },
      }),
    }),
    changeOrgMemberRole: builder.mutation({
      query: ({ accountId, email, role }) => ({
        url: `/org/${accountId}/members/${encodeURIComponent(email)}/role`,
        method: 'POST',
        body: { role },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'OrgMembers', id: arg.accountId }],
    }),
    removeOrgMember: builder.mutation({
      query: ({ accountId, email }) => ({
        url: `/org/${accountId}/members/${encodeURIComponent(email)}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'OrgMembers', id: arg.accountId }],
    }),
  }),
});

export const {
  useGetOrgMeQuery,
  useLazyGetOrgMeQuery,
  usePatchOrganizationNameMutation,
  useGetOrgMembersQuery,
  useGetOrgInvitesQuery,
  useInviteOrgMemberMutation,
  useResendOrgInviteMutation,
  useDeleteOrgInviteMutation,
  useAcceptOrgInviteMutation,
  useChangeOrgMemberRoleMutation,
  useRemoveOrgMemberMutation,
} = orgApi;
